import { Alert, Icon } from '@global-ecom/nitro-uds/elements';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useTranslate } from 'hooks/useTranslations';
import { useMiniCart } from 'hooks/useMiniCart';

export const MixedCartErrorMessage = ({
  mixedCartNotAllowed,
}: {
  mixedCartNotAllowed: boolean;
}) => {
  const { isMiniCartVisible } = useMiniCart();
  const t = useTranslate();
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 604px)').matches
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia('(max-width: 604px)').matches);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isPdp = router.asPath.includes('pd');
  const errorMessage =
    isPdp && !isMiniCartVisible ? t('mixedCartPdpError') : t('mixedCartError');

  return (
    <>
      {mixedCartNotAllowed && (
        <>
          {isMobile ? (
            <Alert
              dataTestId="mixed-cart-mobile-error"
              className="px-[12px] py-[8px] text-sm"
              variant="error"
              content={errorMessage}
            />
          ) : (
            <div
              data-test-id="mixed-cart-error-message"
              className="md:col-span-2 px-[12px] py-[8px] border-[1px] rounded-[2px] border-error-20 text-error-50 text-sm font-bold flex flex-row justify-between"
            >
              <div>{errorMessage}</div>
              <Icon size={'2xl'} name="exclamation-filled" />
            </div>
          )}
        </>
      )}
    </>
  );
};
